import { render } from "./vue-tags-input.vue?vue&type=template&id=4a22ff0f&scoped=true"
import script from "./vue-tags-input.js?vue&type=script&lang=js&external"
export * from "./vue-tags-input.js?vue&type=script&lang=js&external"

import "./vue-tags-input.css?vue&type=style&index=0&id=4a22ff0f&lang=css&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a22ff0f"]])

export default __exports__